import React, { useMemo, useRef, useState, useEffect } from 'react';
import cx from 'clsx';
import { WiderTable, TableProps } from '../Table';
import './index.scss';

export const WiderProTable = <T extends Record<string, any>>({
  className,
  loading,
  freeRowsCount = 3,
  data,
  ...rest
}: TableProps<T> & {
  orderBy?: string;
  freeRowsCount?: number;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [, setCaskTop] = useState(242);

  const _loading = useMemo(() => loading, [loading]);

  useEffect(() => {
    setTimeout(() => {
      const targetEle = containerRef?.current?.querySelector(
        `.db-table-wrappedRow:nth-child(${freeRowsCount + 1})`,
      ) as HTMLElement;

      if (targetEle?.offsetTop) {
        setCaskTop(targetEle?.offsetTop);
      }
    });
  }, [data, freeRowsCount]);

  return (
    <div className={cx('db-widerProTable', className)} ref={containerRef}>
      <WiderTable className="db-widerProTable-table" data={data} loading={_loading} {...rest} />
    </div>
  );
};
